import { View, Text, Pressable, ScrollView } from "react-native";
import Icon, { IconType } from "@/ui/Icon";
import { Colors } from "@/constants/Colors";
import { ms } from "@/ui/moderateScale";
import { useRouter } from "@/_router";
import React from "react";
import { useUISlice } from "@/models/useUISlice";
import Menu, { MenuAction } from "@/ui/Menu";

export default function PageContainer({
  children,
  HeaderComponent,
  bgColor,
}: {
  children: React.ReactNode;
  bgColor?: string;
  HeaderComponent?: React.ReactNode;
}) {
  const insets = useUISlice((state) => state.device.safeArea);

  return (
    <View
      style={{
        backgroundColor: Colors.bg,
        width: "100%",
        height: "100%",
        paddingHorizontal: ms(16),
        top: 0,
        paddingTop: insets.top,
        left: 0,
        ...({ position: "fixed" } as any),
      }}
    >
      {HeaderComponent}

      <ScrollView
        style={{
          marginHorizontal: -ms(16),
          flexGrow: 1,
          backgroundColor: bgColor || Colors.bg,
        }}
      >
        {children}
      </ScrollView>
    </View>
  );
}

PageContainer.MobileHeader = ({
  screenHeader,
}: {
  screenHeader?: {
    title?: string;
    right?: {
      menu?: MenuAction[];
      icon?: IconType;
    };
    onBack?: () => void;
    left?: {
      onPress?: () => void;
    };
  };
}) => {
  const router = useRouter();

  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingVertical: ms(4),
      }}
    >
      <Pressable
        onPress={
          screenHeader?.onBack ? screenHeader.onBack : () => router.back()
        }
        style={{
          height: ms(32),
          width: ms(32),
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon
          icon="dismiss"
          style={{
            width: ms(24),
            height: ms(24),
            tintColor: Colors.text,
          }}
        />
      </Pressable>

      {screenHeader?.title && (
        <Text
          style={{
            fontSize: ms(16),
            fontWeight: "600",
            color: Colors.text,
            position: "absolute",
            left: "50%",
            transform: [{ translateX: "-50%" }],
          }}
        >
          {screenHeader.title}
        </Text>
      )}

      <View
        style={{
          flexDirection: "row",
          gap: ms(12),
          alignItems: "center",
          height: ms(48),
        }}
      >
        {screenHeader?.right?.menu && (
          <Menu
            key={JSON.stringify(screenHeader.right.menu)}
            actions={screenHeader.right.menu}
            actionComponent={
              <View
                style={{
                  backgroundColor: Colors.text + "10",
                  height: ms(32),
                  width: ms(32),
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: ms(24),
                }}
              >
                <Icon
                  icon={screenHeader.right.icon}
                  style={{
                    width: ms(20),
                    height: ms(20),
                    tintColor: Colors.accent,
                  }}
                />
              </View>
            }
          />
        )}
      </View>
    </View>
  );
};

PageContainer.HEADER_HEIGHT = ms(72);
PageContainer.MAX_WIDTH = 1000;
